import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { Course, CourseUnit } from '~/payload-types'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export type AsyncReturnType<T extends (...args: unknown[]) => Promise<unknown>> = T extends (
  ...args: unknown[]
) => Promise<infer R>
  ? R
  : never

export function getUnitsFromCourse({ course }: { course: Course }): CourseUnit[] {
  const relatedModules = course.relatedModules?.docs || []
  return (
    relatedModules.flatMap((relation) => {
      if (typeof relation === 'number') {
        return []
      }
      const module_ = relation.module
      if (typeof module_ === 'number') {
        return []
      }

      return module_.units?.filter((unit) => typeof unit !== 'number') || []
    }) ?? []
  )
}
